import { resetForgetPasswordRoute, sendForgetPasswordCodeRoute } from "./forgetPassword.mjs";
import { signInWithEmailRoute } from "./signInWithEmail.mjs";
import { signInWithGoogleTokenRoute } from "./signInWithGoogleToken.mjs";
import { oc } from "@orpc/contract";
//#region src/api/orpc/auth/index.ts
const authContract = oc.prefix("/auth").tag("Auth").router({
	sendForgetPasswordCode: sendForgetPasswordCodeRoute,
	resetForgetPassword: resetForgetPasswordRoute,
	signInWithEmail: signInWithEmailRoute,
	signInWithGoogleToken: signInWithGoogleTokenRoute
});
//#endregion
export { authContract };
